import request from './request'

// 1. 查询企业列表
export const getQuery = (data) =>
  request({ url: '/api/login?name='+data['name'], method: 'get', data })

// 2. 企业认证输入
export const getCertification = (data) =>
  request({ url: '/api/login/business/verify/submit', method: 'post', data })

// 3. 企业认证码认证
export const verifyEnterpriseAuth = (data) =>
  request({ url: '/api/enterprise/auth/verify', method: 'post', data })